import React from 'react';

const Picture = ({
    webpSrc,
    fallbackSrc,
    alt,
    className = '',
    imgClassName = '',
    ...imgProps
}) => {
    const pictureClassName = ['picture', className].filter(Boolean).join(' ');
    const resolvedFallback = fallbackSrc || webpSrc;

    return (
        <picture className={pictureClassName}>
            {webpSrc ? <source srcSet={webpSrc} type='image/webp' /> : null}
            <img
                src={resolvedFallback}
                alt={alt}
                className={imgClassName || undefined}
                {...imgProps}
            />
        </picture>
    );
};

export default Picture;
